import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 page_view event on every React Router navigation. The initial
 * page_view is already fired by the gtag('config') call in index.html, so we
 * skip the entry URL to avoid double-counting.
 *
 * We compare against the tracked URL (not a boolean mount flag) so this is
 * safe under React 18 StrictMode's intentional double-effect invocation in
 * development.
 */
const RouteTracker = () => {
  const { pathname, search, hash } = useLocation();
  // Seed with the entry URL so the very first effect run detects "same URL"
  // and returns without firing (gtag('config') in index.html already fired it).
  const lastTracked = useRef(pathname + search);

  useEffect(() => {
    const url = pathname + search;
    if (lastTracked.current === url) return;
    lastTracked.current = url;
    if (!hash) window.scrollTo(0, 0);
    if (typeof window !== "undefined") {
      window._tfa = window._tfa || [];
      window._tfa.push({ notify: "event", name: "page_view", id: 2129626 });
    }
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: url,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search, hash]);

  return null;
};

export default RouteTracker;
